import { useCan } from "components";
import { useTypedQuery } from "hooks";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { TyreGroupQueryKeys } from "modules/AppointmentDetails/components/VehicleTyres/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DealerLocation } from "models";

export const usePermanentTyreTeamDelivery = (location: DealerLocation | undefined) => {
  const canListDeliveryTypes = useCan(ACL_ACTIVITIES.Search, ACL_RESOURCES.TyreTeamCatalog);

  return useTypedQuery({
    queryKey: TyreGroupQueryKeys.tyreTeamDeliveries(location?.id),
    queryFn: async ({ baseUrl, endpoint, params }) => (await ApiInstance.post(endpoint, params, baseUrl)).data?.deliveries ?? [],
    enabled: location?.is_tyre_team_enabled === true && canListDeliveryTypes
  });
};
